// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZTUTu","active":"styles_active__MZlfv","content":"styles_content__++kx3"};